import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import HabitUsersTable from '../../../HabitsHub/HabitUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyHabitsUsers } from './companyHabitsApi';

/**
 * Company Habits → Employees/Members list.
 * Every user of the current population appears (never-tracked ones with
 * dashes); a row opens their habit profile.
 */
const CHabitsUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyHabitsUsers(params),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Habit Tracker — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and their habit activity. Open a user to see
        their full habit profile.
      </p>

      <HabitUsersTable
        fetcher={fetcher}
        showCompanyColumn={false}
        onOpenUser={(rowData) => navigate(`/${slug}/habits/user?userId=${rowData?._id}`)}
        tableName="company_habits_users"
      />
    </div>
  );
};

export default CHabitsUsers;
